<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import RouterTabs from '@/home/components/RouterTabs.vue';

const { t } = useI18n();
const tabPanel = [
  {
    path: '/explore/journalism',
    label: t('home.explore.journalism.title'),
  },
  {
    path: '/explore/repository',
    label: t('home.explore.repository.title'),
  },
  {
    path: '/explore/organization',
    label: t('home.explore.organization.title'),
  },
  {
    path: '/explore/developer',
    label: t('home.explore.developer.title'),
  },
];
</script>

<template>
  <main class="page-explore">
    <RouterTabs :item-list="tabPanel" />
  </main>
</template>

<style lang="scss" scoped>
</style>
